import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import FilterList from "../../../components/FilterList";
import { AnimatePresence, motion } from "framer-motion";
import BarLoader from "react-spinners/BarLoader";
import { useInView } from "react-intersection-observer";
import BlogPageCard from "./BlogPageCard";

const NoProjects = () => {
    return (
        <div className="text-center h-96 flex items-center justify-center flex-col">
            <h2 className="text-lg font-semibold">No articles found</h2>
            <p className="text-base">Try a different filter</p>
        </div>
    )
}

const AllBlog = (props) => {

    /* Pretty much the same as AllWork, but with different data source and different card component
       Keeping it separate for now in case we want to add more functionality to either one
    */


    const data = useStaticQuery(graphql`
    {
        posts: allStoryblokEntry(
            filter: {field_component: {eq: "blog_page"}}
            sort: {first_published_at: DESC}
          ) {
            edges {
              node {
                id
                uuid
                name
                slug
                full_slug
                content
                created_at
                tag_list
                first_published_at(formatString: "DD.MM.YY")
              }
            }
          }
        filters: allStoryblokDatasourceEntry(
            filter: {parent: {}, data_source: {glob: "*-journal"}}
          ) {
            edges {
              node {
                id
                value
                name
                data_source
              }
            }
          }
        

      }
  `)

    const [workItems, setWorkItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const PAGE_SIZE = 12;

    const [filterCols, setFilterCols] = useState([
        "type-of-blog-journal"
    ])

    const cleanedFilters = data.filters.edges.map((filter) => {
        return {
            id: filter.node.value,
            title: filter.node.name,
            selected: false,
            col: filter.node.data_source
        }
    })


    const [filters, setFilters] = useState(cleanedFilters);


    const firstItems = data.posts.edges.slice(0, PAGE_SIZE);

    const [visibleItems, setVisibleItems] = useState(firstItems);
    const [loadMoreVisible, setLoadMoreVisible] = useState(false);

    useEffect(() => {
        const selectedFilters = filters.filter((filter) => filter.selected);
        const filteredWorkItems = selectedFilters.length === 0
            ? data.posts.edges
            : data.posts.edges.filter((edge) => {
                const tagList = edge.node.tag_list;
                return selectedFilters.every((selectedFilter) => tagList.includes(selectedFilter.id));
            });
        setWorkItems(filteredWorkItems);
        setVisibleItems(filteredWorkItems.slice(0, PAGE_SIZE));
        setLoadMoreVisible(filteredWorkItems.length > PAGE_SIZE);
    }, [data, filters]);

    const loadMore = () => {
        setIsLoading(true);
        setVisibleItems((prevVisibleItems) => [
            ...prevVisibleItems,
            ...workItems.slice(prevVisibleItems.length, prevVisibleItems.length + PAGE_SIZE),
        ]);
        setLoadMoreVisible(visibleItems.length + PAGE_SIZE < workItems.length);
        setIsLoading(false);
    };

    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
    });

    useEffect(() => {
        if (inView && loadMoreVisible && isLoading === false) {
            loadMore();
        }
    }, [inView]);


    const resetFilters = () => {
        filters.forEach((filter) => {
            filter.selected = false;
        });
        setFilters([...filters]);
    }


    // if there is a tag param in the url, filter by that tag

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tagParam = urlParams.get('tag');
        if (tagParam != undefined){
            const tagFilter = filters.find((filter) => filter.id === tagParam);
            if (tagFilter != undefined){
                tagFilter.selected = true;
                setFilters([...filters]);
            }
        }
    }, [])

    return (
        <section className="width pt-[6.5rem] lg:pt-32">

            <FilterList filters={filters} setFilters={setFilters} filterCols={filterCols} resetFilters={resetFilters} />


            {visibleItems && visibleItems.length > 0 ? (<AnimatePresence>

                <ol className="grid lg:grid-cols-2 gap-7 lg:gap-x-6 lg:gap-y-16">

                    {visibleItems.map((item, index) => {
                        const content = JSON.parse(item.node.content)
                        const firstTag = item.node.tag_list[0]

                        return (
                            <React.Fragment key={`journal-item-${item.node.uuid}-fragment`}>

                                <motion.li key={`work-item-${item.node.uuid}`}
                                    layout
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3 }}

                                >
                                    <BlogPageCard image={content.card_image} title={content.title} copy={content.tagline} url={item.node.full_slug} date={item.node.first_published_at} tag={firstTag} />
                                </motion.li>
                                </React.Fragment>
                        )
                    })}
                </ol>
            </AnimatePresence>
            ) : (<NoProjects />)
            }


            <div className="flex items-center justify-center text-center text-xl py-8 lg:py-9">
                {loadMoreVisible && <div ref={ref}>
                    <BarLoader color="#000" loading={true} />
                </div>}
            </div>

        </section >
    )
}

export default AllBlog